import React, { useEffect, useState } from "react";
import useLocales from "../../../../hooks/useLocales";
import httpRequest from "../../../../axios/index";
import toast from "react-hot-toast";

const VisitorByDayAndTime = () => {
  const { translate } = useLocales();

  const data = ["1", "2", "3", "4", "5", "6", "7"];
  const weekdays = [
    translate("user_analytics.sun"),
    translate("user_analytics.mon"),
    translate("user_analytics.tue"),
    translate("user_analytics.wed"),
    translate("user_analytics.thu"),
    translate("user_analytics.fri"),
    translate("user_analytics.sat"),
  ];
  const times = [
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
    "23:00",
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
  ];

  const additionalNumbers = [5, 45, 85, 125, 165];

  const colors = [
    "bg-red-200",
    "bg-blue-200",
    "bg-green-200",
    "bg-blue-100",
    "bg-purple-200",
  ];
  const [analyticsdata, setAnalyticsData] = useState([]);

  const getAnalyticsData = async () => {
    try {
      const { userid } = JSON.parse(localStorage.getItem("user")) || {};
      const resp = await httpRequest.get(`api/user/getanalyticsdata/${userid}`);
      const platforms = resp.data?.data;

      // Define the range of days and hours
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const hours = Array.from({ length: 24 }, (_, i) => i);

      // Create an object to store the data
      const analyticsData = {};

      // Initialize the object with 0 counts for each day and hour
      days.forEach((day) => {
        analyticsData[day] = {};
        hours.forEach((hour) => {
          analyticsData[day][hour] = 0;
        });
      });

      platforms.forEach((entry) => {
        const createdAt = new Date(entry.createdAt);
        const day = days[createdAt.getDay()];
        const hour = createdAt.getHours();

        // Check if columnType is not an empty string and is one of the specified platforms
        if (
          entry.columnType &&
          [
            "Instagram",
            "Facebook",
            "Twitter",
            "LinkedIn",
            "Pinterest",
            "YouTube",
          ].includes(entry.columnType)
        ) {
          // Increment count only if columnType is valid
          analyticsData[day][hour]++;
        }
      });

      // Convert the analytics data into the required format
      const formattedData = [];
      days.forEach((day) => {
        const dayData = { days: day, times: [] };
        hours.forEach((hour) => {
          dayData.times.push({
            time: `${hour}:00`,
            count: analyticsData[day][hour],
          });
        });
        formattedData.push(dayData);
      });

      setAnalyticsData(formattedData);
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    getAnalyticsData();
  }, []);

  // Define colors based on count
  const getColorBasedOnCount = (count) => {
    if (count === 0) {
      return "rgba(239, 225, 255, 1)"; // Background color for 0 count
    } else if (count <= 10) {
      return "rgba(223, 196, 255, 1)"; // Background color for low count
    } else if (count <= 20) {
      return "rgba(191, 136, 255, 1)"; // Background color for medium count
    } else {
      return "rgba(148, 57, 255, 1)"; // Background color for high count
    }
  };

  const getFullWeekday = (weekdayAbbreviation) => {
    switch (weekdayAbbreviation) {
      case "Sun":
        return "Sunday";
      case "Mon":
        return "Monday";
      case "Tue":
        return "Tuesday";
      case "Wed":
        return "Wednesday";
      case "Thu":
        return "Thursday";
      case "Fri":
        return "Friday";
      case "Sat":
        return "Saturday";
      default:
        return weekdayAbbreviation;
    }
  };


  // Function to get total count for a specific day range
  const getDayRangeCount = (startDay, endDay) => {
    const startDayData = analyticsdata.find((data) => data.days === startDay);
    const endDayData = analyticsdata.find((data) => data.days === endDay);

    if (startDayData && endDayData && startDayData.times && endDayData.times) {
      const startCount = startDayData.times.reduce(
        (total, timeData) => total + timeData.count,
        0
      );
      const endCount = endDayData.times.reduce(
        (total, timeData) => total + timeData.count,
        0
      );
      return startCount + endCount;
    }
    return 0;
  };

  // Function to get total count for a specific day
  const getDayCount = (day) => {
    const dayData = analyticsdata.find((data) => data.days === day);
    if (dayData && dayData.times) {
      return dayData.times.reduce(
        (total, timeData) => total + timeData.count,
        0
      );
    }
    return 0;
  };

    // Aggregate counts for each pair of days
    const sunToMonCount = getDayRangeCount("Sunday", "Monday");
    const tueToWedCount = getDayRangeCount("Tuesday", "Wednesday");
    const thuToFriCount = getDayRangeCount("Thursday", "Friday");
    const satCount = getDayCount("Saturday");
    const sundayCount = getDayCount("Sunday");

  return (
    <div className="col-span-6 md:col-span-3">
      <div className="bg-light_bg_v5 dark:bg-dark-secondary rounded-lg md:rounded-t-[10px] ">
        <h6 className="text-custom_h6 dark:text-color_v1_dark">
          {translate("user_analytics.visitor_by_day")}
        </h6>
        <div className="grid grid-cols-1 gap-4 mt-4">
          {times.map((time, timeIndex) => (
            <div key={timeIndex} className="flex items-center py-0 my-0">
              <div className="flex items-center">
                {weekdays.map((weekday, dayIndex) => {
                  const fullWeekday = getFullWeekday(weekday);

                  const dayData = analyticsdata.find(
                    (data) => data.days === fullWeekday
                  );
                  if (dayData && dayData.times) {
                    const countData = dayData.times.find(
                      (data) => data.time === time
                    );
                    const count = countData ? countData.count : 0;
                    const color = getColorBasedOnCount(count);
                    return (
                      <div
                        key={dayIndex}
                        className="w-[54px] h-4 mr-3"
                        style={{ backgroundColor: color }}
                      />
                    );
                  } else {
                    return (
                      <div
                        key={dayIndex}
                        className={`w-12 h-4 mr-2`}
                        style={{ backgroundColor: "rgba(239, 225, 255, 1)" }}
                      />
                    );
                  }
                })}
              </div>
              <span className="text-gray-500 dark:text-color_v2_dark text-sm ml-4">
                <strong>{time}</strong>
              </span>
            </div>
          ))}

          <div className="flex items-center py-0 my-0">
            <div className="flex items-center">
              {weekdays.map((day, dayIndex) => (
                <div
                  key={dayIndex}
                  className="w-14 h-4 mr-3 dark:text-color_v1_dark"
                >
                  {day}
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center py-0 my-0">
            <div className="flex items-center">
              {[sunToMonCount, tueToWedCount, thuToFriCount, satCount].map(
                (count, index) => (
                  <div
                    key={index}
                    className={`w-[104px] h-4 mr-3`}
                    style={{ backgroundColor: getColorBasedOnCount(count) }}
                  />
                )
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center mt-4 space-x-14 w-[79%] justify-between">
          {[sundayCount, sunToMonCount, tueToWedCount, thuToFriCount, satCount].map(
            (count, index) => (
              <div
                key={index}
                className="text-center dark:text-color_v1_dark"
              >
                {count}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default VisitorByDayAndTime;
